var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"changelog"},[(_vm.changes.html)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.changes.html)}})]:[_c('CenteredMessage',{attrs:{"spinner":true}},[_vm._v("Lädt Neuerungsansicht...")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }